import React from 'react';

const Confetti = () => {
  const colors = ['#ff0', '#0f0', '#0ff', '#f0f', '#f00', '#00f'];
  const pieces = Array.from({ length: 80 });

  return (
    <div className="confetti-container">
      {pieces.map((_, i) => (
        <span
          key={i}
          className="confetti-piece"
          style={{
            left: Math.random() * 100 + 'vw',
            backgroundColor: colors[Math.floor(Math.random() * colors.length)],
            animationDelay: Math.random() * 3 + 's',
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
